import { AfterViewInit, Component, ElementRef, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-sequence-validation-popup',
  templateUrl: './sequence-validation-popup.component.html',
  styleUrls: ['./sequence-validation-popup.component.scss'],
  standalone: false
})
export class SequenceValidationPopupComponent implements AfterViewInit, OnDestroy {
  initialScrollListener: (() => void) | null = null;
  initialScrollTimer: ReturnType<typeof setTimeout> | null = null;

  constructor(
    public dialogRef: MatDialogRef<SequenceValidationPopupComponent>,
    private elementRef: ElementRef
  ) { }
  htmlContent: any;
  title: any;
  subTitle: any;
  type: 'confirm' | 'dialog' | 'json_viewer' | 'table_viewer' | 'formPendingConfirm' | 'forceTrim' | 'python_execution' | 'alertValidation' = 'confirm';
  confirmBtnText = 'Confirm';
  showConfirmIcon = false;
  isFixedHeight!: boolean;
  showContinueButton = false;
  continueBtnText = 'Continue';

  ngAfterViewInit(): void {
    this.dialogRef.afterOpened().subscribe(() => {
      if (this.type !== 'alertValidation') return;
      const wrapper = this.elementRef.nativeElement.closest('.cdk-global-overlay-wrapper');
      if (!wrapper) return;

      // When the dialog has long content to avoid the browser to auto scroll to bottom.
      wrapper.scrollTop = 0;
      this.initialScrollListener = () => { wrapper.scrollTop = 0; };
      wrapper.addEventListener('scroll', this.initialScrollListener);
      this.initialScrollTimer = setTimeout(() => {
        if (this.initialScrollListener) {
          wrapper.removeEventListener('scroll', this.initialScrollListener);
          this.initialScrollListener = null;
        }
      }, 500);
    });
  }

  ngOnDestroy(): void {
    if (this.initialScrollTimer !== null) {
      clearTimeout(this.initialScrollTimer);
    }
    if (this.initialScrollListener) {
      const wrapper = this.elementRef.nativeElement.closest('.cdk-global-overlay-wrapper');
      wrapper?.removeEventListener('scroll', this.initialScrollListener);
      this.initialScrollListener = null;
    }
  }

  shouldShowPythonRun(runData: any): boolean {
    if (!runData) {
      return false;
    }

    const hasStaticIssues = Array.isArray(runData.staticIssues) && runData.staticIssues.length > 0;
    return !runData.success || hasStaticIssues || !!runData.error || !!runData.stack;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onContinueClick(): void {
    this.dialogRef.close(true);
  }

}
